// src/pages/ReportPage.js
import React from "react";
import NavBar from "../components/NavBar/NavBar";
import ReportDashboard from "../components/Report/ReportDashboard";

export default function ReportPage() {
  return (
    <>
      <NavBar/>
      <main className="web-view">
        <ReportDashboard/>
      </main>
    </>
  );
}